export default __webpack_public_path__ + "files/18f795b7373cd6fac75715c68e96a3fe.gif";